import './w-article-body-news.components.scss'
import BScroll from '@better-scroll/core'
import { hotModuleReload } from '../../../components/common/utilities/hot-module-reload'

const getDifference = (wrapper: Element, scrollWrapper: Element): number => {
  const wrapperWidth = wrapper.getBoundingClientRect().width
  const scrollWrapperWidth = scrollWrapper.getBoundingClientRect().width
  return scrollWrapperWidth - wrapperWidth
}

const initStickyMenu = (): void => {
  if (window.innerWidth > 767) {
    const rhcNode: HTMLElement = document.querySelector('.w-right-hand-column')
    rhcNode && (rhcNode.style.position = 'relative')

    let initialYOffset = window.pageYOffset

    const scrollStickyMenu = (): void => {
      const newYOffset = window.pageYOffset
      const deltaYOffset = initialYOffset - newYOffset

      const stickyNode: HTMLElement = document.querySelector('.w-rhs')
      const isSticky = stickyNode?.getBoundingClientRect().top === 0
      isSticky && (stickyNode.scrollTop += -deltaYOffset)

      initialYOffset = newYOffset
    }

    window.addEventListener('scroll', scrollStickyMenu)
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const scrollConfiguration: object = {
    scrollX: true,
    eventPassthrough: 'vertical',
    probeType: 3,
  }

  const tableWrappers = document.querySelectorAll('.w-table-wrapper')

  window.addEventListener('resize', () => {
    tableWrappers.forEach((wrapper) => {
      const scrollWrapper = wrapper.querySelector('.w-scroll-table-wrapper') as HTMLElement
      const tableBorder = wrapper.querySelector('.w-table-border') as HTMLElement
      const difference = getDifference(wrapper, scrollWrapper)
      difference <= 0 ? (tableBorder.style.display = 'none') : (tableBorder.style.display = 'block')
    })
  })

  tableWrappers.forEach((wrapper) => {
    const scrollWrapper = wrapper.querySelector('.w-scroll-table-wrapper') as HTMLElement
    const tableBorder = wrapper.querySelector('.w-table-border') as HTMLElement

    const scroller = new BScroll(wrapper as HTMLElement, scrollConfiguration)

    const difference = getDifference(wrapper, scrollWrapper)
    if (difference <= 0) {
      tableBorder.style.display = 'none'
    }

    scroller.on('scroll', (pos) => {
      const difference = getDifference(wrapper, scrollWrapper)

      pos.x < 0 && pos.x < -difference
        ? (tableBorder.style.right = -(pos.x + difference) + 'px')
        : (tableBorder.style.right = '0')
    })

    window.addEventListener('resize', () => {
      scroller.refresh()
    })
  })
  initStickyMenu()
})

hotModuleReload()
